import { defaultDetailsNuGres } from './state'


/**
 * Mutación manipular/alterar usar/no-usar selector de ítem de naciones unidas en el formulario de crear.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setUseSelectNuGreInFrom(state, nextState) {
    state.useSelectNuGreInFrom = nextState
}

/**
 * Mutación manipular/alterar paginación home nu - gre.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setTableConfigPaginationNuGre(state, nextState) {
    state.tableConfig.dataFields = nextState
}

/**
 * Mutación manipular/alterar paginación detalles de las guias.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setTableConfigPaginationGuidesDetails(state, nextState) {
    state.tableConfig.dataFieldsDetails = nextState
}

/**
 * Mutación manipular/alterar el estado de la acción que se esta realizando.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setAction(state, nextState) {
    state.action = nextState
}

/**
 * Mutación manipular/alterar el listado.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setResponseGuidesOfEmergencies(state, nextState) {
    state.responseGuidesOfEmergencies = nextState
}

/**
 * Mutación manipular/alterar el listado.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setEmergencyResponseGuides(state, nextState) {
    state.emergencyResponseGuides = nextState
}

/**
 * Mutación manipular/alterar restablecer al data del detalle actual.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetDetailsNuGres(state) {
    state.currentDetailsNuGre = defaultDetailsNuGres();
}

/**
 * Mutación manipular/alterar alterar la data del detalle actual.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setCurrentDetailsNuGre(state, nextState) {
    state.currentDetailsNuGre = nextState;
}

/**
 * Mutación manipular/alterar detalles de las guías de emergencias
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setDetailsOfGuide(state, nextState) {
    state.detailsOfGuide = nextState;
}

/**
 * Mutación manipular/alterar el ID del NU - GRE activo.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setCurrentNuGreActive(state, nextState) {
    state.currentNuGreActive = nextState;
}